import { prop } from 'ramda'
import { makeStyles } from '@material-ui/core/styles'
import faker from 'faker'
import { useState } from 'react'
import ListItemActions from './ListItemActions'

const useStyles = makeStyles({
  listItemContainer: {
    height: 72,
    display: 'flex',
    flexDirection: 'row',
    padding: '0px 16px',
    alignItems: 'center',
    cursor: 'pointer',
    backgroundColor: 'rgb(255, 255, 255)',

    '&.completed': {
      backgroundColor: '#fafafa',

      '&:hover': {
        backgroundColor: '#eeeeee'
      },

      '& .listItemText': {
        color: 'rgb(128, 134, 139)',
        textDecorationLine: 'line-through'
      }
    },

    '&:hover': {
      backgroundColor: 'rgb(232, 240, 254)'
    },

    '& .listItemImage': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '48px',
      width: '48px',
      margin: '0px 16px 0px -8px',

      '& img': {
        borderRadius: '4px',
        boxShadow: 'rgba(0, 0, 0, 0.1) 2px 2px 6px 2px;'
      }
    },

    '& .listItemText': {
      color: 'black',
      fontFamily: '"Google Sans", sans-serif',
      fontSize: '15px',
      fontWeight: '500',
      lineHeight: '21.45px',
      flex: 1
    }
  }
})

const isCompleted = (item) => {
  if (prop('completed', item)) return 'completed'
  return ''
}

const ListItem = ({ item }) => {
  const classes = useStyles()

  const [hovering, setHovering] = useState(false)

  return (
    <div
      className={`${classes.listItemContainer} ${isCompleted(item)}`}
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
    >
      <div className={'listItemImage'}>
        <img src={faker.image.food(40, 40)} alt="" />
      </div>
      <div className={'listItemText'}>
        <span>{prop('value', item)}</span>
      </div>
      {hovering && <ListItemActions item={item} />}
    </div>
  )
}

export default ListItem
